import { Injectable } from '@angular/core';
import {
  VehicleTableDto,
  VehicleTableRow,
  VehicleTableRowDto,
} from '../../models/vehicle/vehicle-list.model';
import { CityParkingUserLineResponse } from '../../models/lineOA.model';

@Injectable({
  providedIn: 'root',
})
export class MapperVehicleListService {
  mapTableFromDto(dto: VehicleTableDto): {
    items: VehicleTableRow[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  } {
    const raw = dto as VehicleTableDto & Record<string, unknown>;
    const rows = (dto.data ?? raw['Data'] ?? []) as VehicleTableRowDto[];
    const total = dto.total ?? (raw['Total'] as number) ?? 0;
    const pageSize = dto.pageSize ?? (raw['PageSize'] as number) ?? 20;

    return {
      items: rows.map((row) => this.normalizeRow(row)),
      total,
      page: dto.page ?? (raw['Page'] as number) ?? 1,
      pageSize,
      totalPages: dto.totalPages ?? (raw['TotalPages'] as number) ?? Math.ceil(total / pageSize),
    };
  }

  private normalizeRow(item: VehicleTableRowDto): VehicleTableRow {
    const raw = item as VehicleTableRowDto & Record<string, unknown>;
    return {
      id: item.id ?? (raw['Id'] as number) ?? 0,
      plateNumber: item.plateNumber ?? (raw['PlateNumber'] as string) ?? '',
      provinceName: item.provinceName ?? (raw['ProvinceName'] as string) ?? '',
      vehicleType: item.vehicleType ?? (raw['VehicleType'] as string) ?? '',
      fullName: item.fullName ?? (raw['FullName'] as string) ?? '',
      uid: item.uid ?? (raw['Uid'] as string) ?? '',
      phone: item.phone ?? (raw['Phone'] as string) ?? '',
      createDate: (item.createDate ?? raw['CreateDate'] ?? null) as string | null,
      hasActiveShare:
        item.hasActiveShare ?? (raw['HasActiveShare'] as boolean) ?? false,
      activeShareGroupId:
        (item.activeShareGroupId ?? raw['ActiveShareGroupId'] ?? null) as number | null,
      sharedMemberCount:
        item.sharedMemberCount ?? (raw['SharedMemberCount'] as number) ?? 0,
      cpUserId: item.cpUserId ?? (raw['CpUserId'] as number) ?? 0,
      ownerName: item.ownerName ?? (raw['OwnerName'] as string) ?? '',
      pictureUrl: item.pictureUrl ?? (raw['PictureUrl'] as string) ?? '',
      language: item.language ?? (raw['Language'] as string) ?? '',
      userStatusId: item.userStatusId ?? (raw['UserStatusId'] as number) ?? 0,
    };
  }

  mapOwnerMember(row: VehicleTableRow): CityParkingUserLineResponse {
    return {
      id: row.cpUserId,
      cpUserId: row.cpUserId,
      name: row.ownerName,
      fullName: row.fullName,
      uid: row.uid,
      phone: row.phone,
      pictureUrl: row.pictureUrl,
      userStautsId: row.userStatusId,
      language: row.language,
      createDate: null,
    };
  }
}
